import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { organizationsService } from '../api/organizations.service';
import { ORGANIZATIONS_KEYS } from './queryKeys';
import type { CreateOrganizationPayload } from '../types';

export function useCreateOrganization() {
  const queryClient = useQueryClient();
  const setActiveOrganization = useOrganizationStore((s) => s.setActiveOrganization);

  return useMutation({
    mutationFn: (payload: CreateOrganizationPayload) => organizationsService.create(payload),

    onSuccess: (organization) => {
      queryClient.invalidateQueries({ queryKey: ORGANIZATIONS_KEYS.all });
      setActiveOrganization(organization.id);
    },
  });
}
